import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Modal from '../../../../Modal';
import { getCruiseBenefitsRequest } from '../../../../../store/slices/cruise';
import { SearchStatus } from '../../../../../constants';
import MarkdownToHtml from '../../../../MarkdownToHtml';
import withSpinner from '../../../../../HOCs/withSpinner';

const CruiseBenefitsModal = ({ virtuosoVoyage, open, onClose }) => {
  const dispatch = useDispatch();
  const { cruiseBenefits, cruiseBenefitsError, getCruiseBenefitsStatus } = useSelector(
    (store) => store.cruise,
  );

  const selectedTabClasses = 'text-theme border-b-2 border-theme';
  const [selectedTab, setSelectedTab] = useState(0);
  const handleTabChange = (index) => {
    setSelectedTab(index);
  };

  const cruiseBenefitsToDisplay = useMemo(
    () => cruiseBenefits || virtuosoVoyage.cruiseBenefits,
    [cruiseBenefits, virtuosoVoyage.cruiseBenefits],
  );

  useEffect(() => {
    dispatch(getCruiseBenefitsRequest(virtuosoVoyage.id));
  }, [dispatch, virtuosoVoyage.id]);

  return (
    <Modal open={open} onClose={onClose}>
      <div className="p-8">
        <div className="text-theme font-bold sm:text-sm xl:text-lg">Cruise benefits:</div>
        <div className="font-bold my-2">Virtuoso Benefits on Your Sailing</div>
        {cruiseBenefitsToDisplay && cruiseBenefitsToDisplay.length > 1 ? (
          <div className="font-bold my-2">Guests may select one of the following benefits.</div>
        ) : (
          <></>
        )}
        {virtuosoVoyage.cruiseBenifitsNote && (
          <div className="mb-2">{virtuosoVoyage.cruiseBenifitsNote}</div>
        )}
        <div className="flex gap-5 border-b-2 mb-5">
          {cruiseBenefitsToDisplay.map((tab, index) => (
            <a
              key={tab.title}
              onClick={() => {
                handleTabChange(index);
              }}
              onKeyDown={() => {
                handleTabChange(index);
              }}
              role="button"
              tabIndex={cruiseBenefitsToDisplay.length - index}
              className={clsx(
                selectedTab === index && selectedTabClasses,
                'flex-auto py-4 text-sm mt-auto md:text-base lg:w-24 text-center focus:outline-none block w-full',
              )}
            >
              {tab.title || tab.name}
            </a>
          ))}
        </div>
        {withSpinner(
          () => (
            <div>
              {cruiseBenefitsError || (
                <MarkdownToHtml
                  content={cruiseBenefitsToDisplay[selectedTab].description}
                  className="max-w-none"
                />
              )}
            </div>
          ),
          getCruiseBenefitsStatus === SearchStatus.SEARCHING,
          'Searching for details...',
        )}
      </div>
    </Modal>
  );
};

CruiseBenefitsModal.propTypes = {
  virtuosoVoyage: PropTypes.shape().isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default CruiseBenefitsModal;
